var path = 'jangl/jangl-checkbox/template.html';
var html = "<div class=checkbox> <label ng-class=\"{ 'required': $ctrl.required }\"> <input type=checkbox name={{$ctrl.name}} ng-model=$ctrl.model ng-checked=\"$ctrl.model == true\" ng-required=$ctrl.required /> <ng-transclude></ng-transclude> </label> <div class=error-messages ng-show=\"$ctrl.form.$submitted || $ctrl.form[$ctrl.name].$touched\"> <div ng-repeat=\"err in $ctrl._errorMessages\" ng-show=$ctrl.form[$ctrl.name].$error[err.type]>{{err.msg}}</div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/jangl/jangl-checkbox/template.html
// module id = 376
// module chunks = 0